import { useState, useEffect } from 'react'
import { NavbarContent } from 'shared-content'
import { Navbar } from 'component-library'
import { useAuth0 } from '@auth0/auth0-react'
import { gql } from '@apollo/client'
import { GraphQLClient } from 'graphql-request'
import LinkComponent from '../LinkComponent/LinkComponent'
import { getCurrentEnvConfig } from '../../../config'
import { useLocation } from '@reach/router'

const config = getCurrentEnvConfig()

const GET_USER_HANDLE = gql`
  query GetUserHandle($userId: UserID) {
    profile(userId: $userId) {
      handle
    }
  }
`

const graphQLClient = new GraphQLClient(config.graphql)

const NavBarWrapper = () => {
  const { isAuthenticated, loginWithRedirect, logout, user } = useAuth0()
  const [userHandle, setUserHandle] = useState<string>()

  const location = useLocation()

  useEffect(() => {
    if (isAuthenticated && user && user.sub) {
      getUserHandle(user.sub)
        .then((profile: { handle: string }) => {
          setUserHandle(profile.handle)
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }, [isAuthenticated, user])

  const getUserHandle = async (userId: string) => {
    const data: {
      profile: {
        handle: string
      }
    } = await graphQLClient.request(GET_USER_HANDLE, {
      userId,
    })
    return data.profile
  }

  return (
    <Navbar
      activePath={location.pathname}
      isAuthenticated={isAuthenticated}
      leftItems={NavbarContent.navbarLeft}
      rightItems={NavbarContent.navbarRight}
      mobileButton={NavbarContent.mobileButton}
      LinkComponent={LinkComponent}
      handle={userHandle}
      createAccount={() => {
        loginWithRedirect({
          authorizationParams: { screen_hint: 'signup' },
        })
      }}
      logIn={() => {
        loginWithRedirect({ appState: { returnTo: window.location.pathname } })
      }}
      signOut={() => {
        logout({
          logoutParams: {
            returnTo:
              typeof window !== 'undefined' ? `${window.location.origin}` : '',
          },
        })
      }}
    />
  )
}

export default NavBarWrapper
